import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { TFunction } from "i18next";
import { CrewOverrideCount } from "src/store/api/generatedApi";
import { formatHeatIdRanges } from "src/utils/formatHeatIdRanges";

export type RenderVariant = "interactive" | "static";

export const OverrideCountCell = ({
  cell,
  rowKind,
  variant,
  t,
}: {
  cell: CrewOverrideCount;
  rowKind: "reason" | "total";
  variant: RenderVariant;
  t: TFunction;
}) => (
  <Stack direction="row" alignItems="center" justifyContent="center" gap={0.5}>
    <Typography
      variant="body1"
      sx={rowKind === "total" ? { fontWeight: "fontWeightBold" } : undefined}
    >
      {cell.count || (rowKind === "total" ? 0 : "—")}
    </Typography>
    {variant === "interactive" &&
    cell.count > 0 &&
    cell.stable_heat_ids?.length ? (
      <Tooltip
        arrow
        title={
          <Box sx={{ maxHeight: 240, overflowY: "auto" }}>
            <Typography variant="body2">{t("heats")}</Typography>
            <Typography variant="body2Mono" component="p">
              {formatHeatIdRanges(cell.stable_heat_ids)}
            </Typography>
          </Box>
        }
      >
        <IconButton
          size="small"
          aria-label={t("heats")}
          sx={{ p: 0, color: "text.disabled" }}
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    ) : null}
  </Stack>
);
